export default __webpack_public_path__ + "static/media/silver1.43f8bf4e.png";